import "./SingleArtistTemplate.module.css"
import Header from "@/reusable_sections/Header"
import SingleArtistTemplateSection from "./sections/SingleArtistTemplateSection"
import GamingSocialFooter from "@/reusable_sections/Footer"

export default function SingleArtistTemplatePage() {

  return (
    <div>
      <Header />
      <SingleArtistTemplateSection />
      <GamingSocialFooter />
    </div>
  )
}
